import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import CartButton from 'components/cart/button';
import Login from './login';
import Search from 'components/search';
import Address from './address';
import HeaderNav from './nav';
import Banner from '../banner';
import AsyncAvailabilityModal from 'components/availability/async';
import NavWrapper from './NavWrapper';
import AppHeader from './AppHeader';
import { logoContainer } from './navWrapper.mod.scss';
import WordmarkIcon from 'images/icons/logos/wordmark.svg?react-svg';
import { inlineBlock } from 'scy/display.mod.scss';
import styles from './styles.mod.scss';

export default function Header({
  cartOpen,
  isScrollingDown,
  headerRef,
  toggleRef,
  onClick
}) {
  return (
    <div className={styles.container} onClick={onClick}>
      <AppHeader
        cartOpen={cartOpen}
        isScrollingDown={isScrollingDown}
        headerRef={headerRef}
      >
        <NavWrapper className={styles.navWrapper} toggleRef={toggleRef}>
          <Link to="/" className={classnames(logoContainer, inlineBlock)}>
            <WordmarkIcon />
          </Link>
          <HeaderNav />
          <Login />
        </NavWrapper>

        <div className={styles.searchBarContainer}>
          <Search ariaLabel={`What can we help you find?`} />
          <Address trackingParams={{ source: 'Header' }} />
          <div className={styles.cartButtonContainer}>
            <CartButton className={styles.cartButton} />
          </div>
        </div>

        <Banner />

        <AsyncAvailabilityModal />
      </AppHeader>
    </div>
  );
}
